export default "__VITE_ASSET__CBb0fT9g__"